import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './cellphoneplane.json'; 

const CellPhonePlane = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Mobile phone etiquette, flight mode, and travel tech vocabulary. B2 level grammar, reading, and discussion exercises."
            level="B2"
            title="Airplane Mode"
            image="/Images/airplanemode.webp"
            seoTitle="Free English Lesson Plans: Airplane Mode"
            seoDescription="Mobile phone etiquette, flight mode, and travel tech vocabulary. B2 level grammar, reading, and discussion exercises."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default CellPhonePlane;


